import { useState , useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { priceFormat } from 'util/prices';
import { BASE_PATH_API } from 'constants/env';
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'
import ModuleOTP from 'newComponents/Validate2FA/OTP';
import ModulePhone from 'newComponents/Validate2FA/Phone';
import iconGift from 'assets/img/buscar.png'
import { decodeStorage } from 'functions/storageBase64';
import ModuleSelected from 'newComponents/Validate2FA/SelectedOtp';
import ModalOTP from '../../Modal'
import styles from './styles.module.sass'


const GiftsRecived = (props) => {

    const {
        eventID,
        responseTable,
        eventWallet,
        setMonedero,
        setEdosCuenta
    } = props

    const valorTotal = 5000
    const isMobile = 'desktop'
    const title = 'Monedero SEARS'
    const agent_table_id = window.location.search.split('agent_table_id=')[1]
    
    const history = useHistory();
    const routeUrl = window.location.search
    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)

    const [ listOfReceivedGifts, setListOfReceivedGifts ]= useState(null)
    const [ orders, setLOrders ]= useState([])

    const [ showModalSelected, setShowModalSelected ]= useState(false)
    const [ showModalPhone, setShowModalPhone ]= useState(false)
    const [ showModalOTP, setShowModalOTP ]= useState(false)
    const [ phoneExist, setPhoneExist ]= useState(false)
    
    const [ typeEvent, setTypeEvent ]= useState(null)
    const [ typeMask, setTypeMask ]= useState(null)

    const [ faltaPremio, setFaltaPremio ]= useState(valorTotal)
    const [ totalSaldo, setTotalSaldo ]= useState(0)

    const [showHeader, setShowHeader ] = useState(true)

    /* saldos */
    const [ walletService, setWalletService ]= useState(null)
    const accessToken = `Bearer ${ decodeStorage('access_token') }`

    const getWalletData = async (eventIDWallet) => {
        dispatch(showLoader());
        const idsFilter = String(eventIDWallet)
        try {
            const header = {
                headers: { 'Authorization': accessToken }
            }
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/electronic-wallet/${idsFilter}`, header);
            const data = await response.json();
            setWalletService(data?.data)
        } catch (error) {
            dispatch(hideLoader());
            // console.error('Error fetching getEventTable data:', error);
        }
    }

    const [ totalAmount, setTotalAmount ] = useState('$0')
    const [ dispAmount, setDispAmount ] = useState('$0')
    useEffect(()=>{
        if(walletService){
            dispatch(hideLoader());
            const totalAmountA = walletService?.total_amount
            const currentAmountA = walletService?.current_amount
            let current; let total
            
            if( isNaN(currentAmountA) ){
                current = currentAmountA
            }else{
                current = `$${priceFormat( Number(currentAmountA) ) }`
            }

            if( isNaN(totalAmountA) ){
                total = totalAmountA
            }else{
                total = `$${priceFormat( Number(totalAmountA) ) }`
            }

            setTotalAmount(total)
            setDispAmount(current)
        }
    },[walletService])
    /* saldos */



    const getEventTable = async (event_ID) => {
        dispatch(showLoader());
        const idsFilter = String(event_ID)
        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table/${idsFilter}/orders?all_orders=false`);
            const data = await response.json();
            setListOfReceivedGifts(data?.data)
        } catch (error) {
            // console.error('Error fetching getEventTable data:', error);
        }
    }

    const handleRowClick = (idOrderNumber) => {
        history.push(`/regalos-recibidos/${idOrderNumber}/details`)
    };

    const [ showModalNoMail, setShowModalNoMail ] = useState(false)
    const handleRowClickFake = () => {
        setShowModalNoMail(true)
        // console.log('El usuario no dejo un correo electrónico para recibir agradecimiento')
    };
        
    const handleDetailClick = (idOrderNumber) => {
        history.push(`/regalos-recibidos/${idOrderNumber}/detailsv2`)
    };
    
    // Open Modal --- primer paso desde que se selecciona el boton
    const sendModalWallet = () => {
        setShowModalSelected(true)
        
        // setShowModalPhone(true)
        setMonedero(null)
        setEdosCuenta(false)
        // if(phoneExist?.length <= 5 ){
        //     setShowModalPhone(true)
        // }else{
        //     setShowModalOTP(true)
        // }
    }
        
    // close Modal
    const handleClose = () => {
        setShowModalPhone(false)
        setShowModalOTP(false)
        setShowModalSelected(false)
        setTypeEvent(null)
    }

    const changeEvent = () => {
        setShowModalPhone(false)
        setShowModalOTP(false)
        setShowModalSelected(true)
        setTypeEvent(null)
        setShowModalNoMail(false)
    }

    // response Modal Success
    const successPhone = (phone) =>{
        const telephone = String(phone)
        setPhoneExist(String(telephone))
        setShowModalPhone(false)
        setShowModalOTP(true)
    }

    const successOTP = (data) =>{
        setShowModalOTP(false)
        setMonedero(data)
    }

    useEffect(()=>{
        if(typeEvent){
            setShowModalOTP(true)
            setShowModalSelected(false)
        }
    },[typeEvent])

    const [ wallet, setWallet ] = useState(false)
    useEffect(()=>{
        const agentStaff = routeUrl?.indexOf('agent_staff')
        // const agentID = routeUrl?.indexOf('agent_table_id')
        
        if(agentStaff >= 1){
            setShowHeader(false)
            setWallet(true)
        }
    },[])

    useEffect(()=>{
        if(wallet){
            if(eventWallet?.wallet_id){
                const idWallet = eventWallet?.wallet_id
                getWalletData(idWallet)
            }
        }
    },[ wallet, eventWallet?.wallet_id ])

    useEffect(()=>{
        if(responseTable?.customer){
            const Cel = responseTable?.customer?.phone_customer
            setPhoneExist(String(Cel))
        }
    },[responseTable])

    useEffect(()=>{
        if(eventID){
            getEventTable(eventID)
        }else if(agent_table_id){
            getEventTable(agent_table_id)
        }
    },[eventID])

    useEffect(()=>{
        if(listOfReceivedGifts){
            dispatch(hideLoader());
            setLOrders(listOfReceivedGifts?.orders)
            const total = listOfReceivedGifts?.orders ? listOfReceivedGifts?.orders.reduce((accumulator, currentObject) => accumulator + Number(currentObject.total_paid), 0) : null;
            setTotalSaldo(total)
            const paraPremio = valorTotal - total
            if(paraPremio <= 0){
                setFaltaPremio(0)
            }else{
                setFaltaPremio(paraPremio)
            }
        }
    },[listOfReceivedGifts])


    return(
        <>
            <div className={styles?.contAcumulate}>

                {faltaPremio
                    ?
                        <div className={styles?.premio}>¡Te faltan <span>{faltaPremio ? `${priceFormat(faltaPremio)}` : 0 }</span> para desbloquear tu regalo!</div>
                    : 
                        <div className={styles?.premio}>Desbloqueaste tu regalo</div>
                }
                
                <progress id="file" max={valorTotal} value={totalSaldo} className={styles?.progressBar}/>
               
                <div className={styles?.totalAcumulado}>
                    <p>Total acumulado:</p>
                    <p>{totalSaldo ?  `$ ${priceFormat(totalSaldo)}` : 0}</p>
                </div>

                {!showHeader
                    ?
                        <div className={styles?.contWallets}>
                            <div className={styles?.totalAcumulado}>
                                <p>Total transferido a monedero:</p>
                                <p>{totalAmount}</p>
                            </div>
                            
                            <div className={styles?.totalAcumulado}>
                                <p>Saldo actual disponible:</p>
                                <p>{dispAmount}</p>
                            </div>
                        </div>
                    : null
                }

               
               {showHeader
                    ?
                        <div 
                            className={`${styles?.buttonWallet} btn primaryButton `}
                            onClick={sendModalWallet}
                            aria-hidden
                        >Ver monedero SEARS</div>
                    : null
               }

            </div>

            <div className={styles?.contTableOrders}>
                <h2 className={styles?.subTitmes}>Mis regalos</h2>
                <div>
                    {orders?.length === 0
                        ?
                            <div className={styles.ajusteIcono}>
                                <img src={iconGift} alt=""/>
                                <p className="text-center mt-5">No tienes regalos recibidos aún</p>
                            </div>
                        :
                        orders?.map(item => (
                            item?.products?.map((product,index) => {
                                const imageProduct = product?.product_image
                                // const precioUnitario = Number(product?.unit_price) || 0

                                const precioUnitario = Number(product?.unit_price * product?.quantity) || 0
                                // const precioUnitario = Number(item?.total_paid) || 0

                                return(
                                    <div className={styles?.contMyOrders} key={index}>
                                        <div className={styles?.space1}>
                                            <img 
                                                src={imageProduct} 
                                                alt={product?.product_name}
                                                className={styles?.contImage}
                                            />
                                        </div>
                                        <p className={styles?.space2}>{item?.guest_name}</p>
                                        <p className={styles?.space3}>{item?.congrats_message}</p>
                                        <p className={styles?.space4}>{product?.product_name}</p>
                                        <p className={styles?.space5}>{product?.unit_price ? `$${priceFormat(precioUnitario)}` : 'No disponible por el momento'}</p>
                                        {/* <p className={styles?.space5}>{item?.total_paid ? `$${priceFormat(precioUnitario)}` : 'No disponible por el momento'}</p> */}

                                        <div className={styles?.space7}>
                                            <span 
                                                onClick={() => handleDetailClick(item?.internal_order_number)} 
                                                className='btn secondaryButton'
                                                aria-hidden
                                            >Ver detalle</span>
                                        </div>

                                        {item?.thanks_message_sent === true
                                            ? null
                                            :
                                                <div className={styles?.space6}>
                                                    <span 
                                                        onClick={
                                                            item?.transaction_origin === 'ecommerce'
                                                            ? () => handleRowClick(item?.internal_order_number)
                                                            : () => handleRowClickFake(item?.internal_order_number)
                                                        } 
                                                        className={
                                                            item?.transaction_origin === 'ecommerce'
                                                            ? 'btn primaryButton'
                                                            : 'btn fourthdButton'
                                                        }
                                                        aria-hidden
                                                    >Agradecer</span>
                                                </div>
                                        }
                                    </div>
                                )}
                            )
                        ))
                        
                    }
                </div>
            </div>

            {showModalSelected
                ? 
                    <ModalOTP
                        onClose={handleClose} 
                        isMobile={isMobile} 
                        type={isMobile === 'desktop' ? '' : 'full'} 
                        title={title} 
                        closeBody="modalPromos"
                    >
                        <ModuleSelected 
                            responseTable={responseTable}
                            handleClose={handleClose}
                            event_ID={eventID}
                            setTypeEvent={setTypeEvent}
                            setTypeMask={setTypeMask}
                        />
                    </ModalOTP>
                : null
            }

            {showModalPhone
                ? 
                    <ModalOTP
                        onClose={handleClose} 
                        isMobile={isMobile} 
                        type={isMobile === 'desktop' ? '' : 'full'} 
                        title={title} 
                        closeBody="modalPromos"
                    >
                        <ModulePhone 
                            handleClose={handleClose}
                            event_ID={eventID}
                            successPhone={successPhone}
                        />
                    </ModalOTP>
                : null
            }

            {showModalOTP
                ? 
                    <ModalOTP
                        onClose={handleClose} 
                        isMobile={isMobile} 
                        type={isMobile === 'desktop' ? '' : 'full'} 
                        title={title} 
                        closeBody="modalPromos"
                    >
                        <ModuleOTP 
                            handleClose={handleClose}
                            phoneExist={phoneExist}
                            event_ID={eventID}
                            successOTP={successOTP}
                            typeEvent={typeEvent}
                            changeEvent={changeEvent}
                            typeMask={typeMask}
                        />
                    </ModalOTP>
                : null
            }

            {showModalNoMail
                ? 
                    <ModalOTP
                        onClose={handleClose} 
                        isMobile={isMobile} 
                        type={isMobile === 'desktop' ? '' : 'full'} 
                        title={title} 
                        closeBody="modalPromos"
                    >
                        <div className={styles?.contModal}>
                            <div className={styles?.closeBtn} onClick={handleClose} aria-hidden>X</div>
                            <div className={styles?.modalBody}>
                                <h1>¡Ups!</h1>
                                <p>El usuario no dejo un correo electrónico para recibir tus agradecimientos</p>
                                <div
                                    onClick={handleClose}
                                    className={`${styles?.buttonSuccess} btn primaryButton`}
                                    aria-hidden
                                >Aceptar</div>
                            </div>
                        </div>
                    </ModalOTP>
                : null
            }
        </>
    )
}

export default GiftsRecived